import { useEffect } from 'react';

export default function TwitterFeed() {
  useEffect(() => {
    // Cargar el script de Twitter widgets
    const script = document.createElement('script');
    script.src = 'https://platform.twitter.com/widgets.js';
    script.async = true;
    script.charset = 'utf-8';
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="bg-gradient-to-br from-purple-800/50 to-blue-800/50 backdrop-blur-sm rounded-3xl p-6 shadow-2xl border border-white/10">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full flex items-center justify-center">
          <i className="ri-twitter-x-fill text-2xl text-white"></i>
        </div>
        <div>
          <h3 className="text-2xl font-bold text-white">Síguenos en X</h3>
          <p className="text-gray-300">@top40star</p>
        </div>
      </div>

      <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 overflow-hidden" style={{ maxHeight: '500px', overflowY: 'auto' }}>
        <a 
          className="twitter-timeline" 
          data-theme="dark" 
          data-chrome="noheader nofooter noborders transparent"
          data-tweet-limit="3"
          href="https://twitter.com/top40star?ref_src=twsrc%5Etfw"
        >
          TOP 40 STAR - Lista Adulta Contemporánea de España
        </a>
      </div>

      <div className="mt-4 text-center">
        <a 
          href="https://twitter.com/top40star" 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-5 py-2 bg-gradient-to-r from-blue-400 to-blue-600 text-white rounded-full font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer text-sm"
        >
          <i className="ri-twitter-x-fill text-lg"></i>
          Seguir en X
        </a>
      </div>
    </div>
  );
}
